interface IElement {
  title: string;
  icon: string;
  message: string;
  description?: string;
  buttonText: string;
}

export default (elementsList: IElement[]) => elementsList[Math.floor(Math.random() * elementsList.length)];
